export const FIELDTYPE_CHECKBOXGROUP = 'C'
export const FIELDTYPE_DROPDOWN = 'B'
export const FIELDTYPE_RADIOBUTTONGROUP = 'R'
export const FIELDTYPE_TABLE = 'TABLE'
export const FIELDTYPE_TEXTFIELD = 'TF'
export const FIELDTYPE_TEXTAREA = 'TA'
export const FIELDTYPE_DROPDOWN_TEXTFIELD = 'B_TF'
export const FIELDTYPE_DATE = "D"
export const FIELDTYPE_CHECKBOX = "CB"
export const FIELDTYPE_PASSWORD = "P"
export const FIELDTYPE_SOCIAL_MEDIA = "SM"
export const FIELDTYPE_NONE = "NONE"
export const FIELDTYPE_HORIZONTAL_LINE = "HL"
export const FIELDTYPE_CUSTOM_COUNTY_DROPDOWN = "CD"
export const FIELDTYPE_CUSTOM_SEARCH_DROPDOWN = "SD"
export const FIELDTYPE_TEXTFIELD_WITH_BUTTON = "TB"
export const FIELDTYPE_SECURITY_QUESTION = "SQ"
export const FIELDTYPE_MULTI_VALUE_TEXTFIELD = "MT"
export const FIELDTYPE_LABEL_TEXTFIELD = "LTF"
export const FIELDTYPE_ALERT_BOX = "AB"
export const FIELDTYPE_LINK= "L"
export const FIELDTYPE_FILTER_DROPDOWN = "FD"


export const HYPHEN = "-"
